export enum SectionColumnConfigProductInfoKey {
  Asset = 'Asset',
  Badges = 'Badges',
  Brand = 'Brand',
  Strain = 'Strain',
  StrainType = 'ClassificationType', // Underlying value must remain ClassificationType for backwards compatibility
  Lineage = 'Lineage',
  Quantity = 'Quantity',
  Size = 'Size',
  QuantityAndSize = 'QuantityAndSize',
  GradingResults = 'GradingResults',
  Price = 'Price',
  SecondaryPrice = 'SecondaryPrice',
  Stock = 'Stock',
  VariantType = 'VariantType',
  HelpsWith = 'HelpsWith',
  Effects = 'Effects',
  Aroma = 'Aroma',
  Appearance = 'Appearance',
  GrowingConditions = 'GrowingConditions',
  CraftDesignation = 'CraftDesignation',
  Flavor = 'Flavor',
  TopFlavor = 'TopFlavor',
  EnergyScore = 'EnergyScore'
}
